import React from "react";

import {
  PUSH_CONFIGURATION,
  PUSH_CONFIRMATION,
  PUSH_MYM_CLOUD,
  PUSH_MYM_CLOUD_COLLECTION,
  PUSH_RECAP,
  PUSH_UPDATE,
  PUSH_UPDATE_CONFIRMATION,
  PUSH_UPDATE_RECAP
} from "@/shared/constants/routes";
import { RouteConfig } from "@/routes/routes";
import { Outlet, Route, Routes } from "react-router-dom";

import PushFormProviderWrapper from "@/features/push/presentation/Push";

const Setup = React.lazy(
  () => import("@/features/push/presentation/pages/setup/Setup")
);

const MymCloud = React.lazy(
  () => import("@/features/push/presentation/pages/mym-cloud/MymCloud")
);

const Collection = React.lazy(
  () => import("@/features/push/presentation/pages/collection/Collection")
);

const Confirmation = React.lazy(
  () => import("@/features/push/presentation/pages/confirmation/Confirmation")
);

const Recap = React.lazy(
  () => import("@/features/push/presentation/pages/recap/Recap")
);

const routesConfig: RouteConfig[] = [
  {
    path: PUSH_CONFIGURATION,
    element: <Setup />,
    isPrivate: true
  },
  {
    path: PUSH_MYM_CLOUD,
    element: <MymCloud />,
    isPrivate: true
  },
  {
    path: PUSH_MYM_CLOUD_COLLECTION,
    element: <Collection />,
    isPrivate: true
  },
  {
    path: PUSH_CONFIRMATION,
    element: <Confirmation />,
    isPrivate: true
  },
  {
    path: PUSH_RECAP,
    element: <Recap />,
    isPrivate: true
  },
  {
    path: PUSH_UPDATE,
    element: <Setup />,
    isPrivate: true
  },
  {
    path: PUSH_UPDATE_RECAP,
    element: <Recap />,
    isPrivate: true
  },
  {
    path: PUSH_UPDATE_CONFIRMATION,
    element: <Confirmation />,
    isPrivate: true
  }
];

export const PushRoutes = () => {
  return (
    <PushFormProviderWrapper>
      <Routes>
        <Route path="/" element={<Outlet />}>
          {routesConfig.map((route, index) => {
            return (
              <Route key={index} path={route.path} element={route.element} />
            );
          })}
        </Route>
      </Routes>
    </PushFormProviderWrapper>
  );
};

export default PushRoutes;
